import { FC } from 'react';

import Modal, { modalClasses } from '@mui/material/Modal';
import Box from '@mui/material/Box';

import { CommonProps } from '../layout/LoanForm';
import { Loader } from './index';

interface Props {
  open: boolean;
  /*handleClose: () => void;
    onAccept: () => void;*/
}

const ValidatingModal: FC<CommonProps & Props> = (props) => {
  const { open } = props;

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={() => ({
        [`.${modalClasses.backdrop}`]: {
          bgcolor: 'var(--modal-bg-color)',
          backdropFilter: 'blur(7.5px)',
        },
      })}
    >
      <Box
        sx={() => ({
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          overflowY: 'scroll',
          maxHeight: '100vh',
          width: '100%',
          height: '100%',
          bgcolor: 'transparent',

          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <Loader />
      </Box>
    </Modal>
  );
};

export default ValidatingModal;
